exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lazyload,.lazyloading{opacity:0}.lazyloaded{opacity:1;transition:opacity .3s}", ""]);

// exports
